function SectionDivider({ fill = 'fill-gray-50 dark:fill-gray-950', flip = false }) {
  return (
    <div
      className={`section-divider w-full overflow-hidden leading-none ${flip ? 'rotate-180' : ''}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 56"
        preserveAspectRatio="none"
        className="block w-full h-5 xs:h-6 sm:h-8 md:h-10"
      >
        <path
          d="M0,32 C360,56 720,8 1080,32 C1260,44 1380,40 1440,32 L1440,56 L0,56 Z"
          className={fill}
        />
      </svg>
    </div>
  );
}

export default SectionDivider;
